module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "full-dialog",
      "title": _vm.$l('streamPopover/Audio') + ' - ' + _vm.data.filename,
      "visible": _vm.data.visible,
      "size": "auto"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.data, "visible", $event)
      }
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.data.filename) ? _c('audio', {
    ref: "audioController",
    staticClass: "audio-controller",
    attrs: {
      "controls": ""
    },
    on: {
      "loadeddata": _vm.audioLoaded
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.fileSource
    }
  })]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "img-popup",
    attrs: {
      "src": _vm.imgSource
    },
    on: {
      "click": _vm.setImgBig
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('img', {
    staticClass: "img-big",
    attrs: {
      "src": _vm.imgSourceBig
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$l('archives/Close')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26ae9a5e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/graphs/PlayAudioFileDialog.vue
// module id = 450
// module chunks = 1